// extracted by mini-css-extract-plugin
export default {"brandButton":"NewsletterSignup_brandButton__M62Rq","getStartedButton":"NewsletterSignup_getStartedButton__HfZe-","section":"NewsletterSignup_section__M-+YF"};